import { mapActions } from "vuex";
import firebase from 'firebase/app';
import * as FirebaseConf from '../../../firebase-config';
import { setCookie, cookiesList } from '@/static';

export default {
    ...mapActions(['changeUnitToVueX']),
    languageSetting() {
        const language = navigator?.language || navigator?.userLanguage;
        let currentLang = navigator.cookieEnabled ? (localStorage.getItem('lang') ?? language) : language;
        const korean = currentLang.includes('ko');
        const chinese = currentLang.includes('zh');
        const czech = currentLang.includes('cs');

        if (korean)
            currentLang = 'ko-kr';
        // TODO: 중국어 운영 배포시 URL 체크 삭제
        else if (!window.location.href.includes('https://manager.rebless.clinic') && chinese)
           currentLang = 'zh';
        // TODO: 체코어 운영 배포시 URL 체크 삭제
        else if (!window.location.href.includes('https://manager.rebless.clinic') && czech)
            currentLang = 'cs';
        else
            currentLang = 'en';

        return currentLang;
    },
    acceptAll() {
        setCookie('essentialCookies', 1, 30, true);
        setCookie('performanceCookies', 1, 30, true);
        setCookie('functionalCookies', 1, 30, true);

        this.essential();
        this.functional();
        this.performance();
    },
    accept(performanceCookies, functionalCookies) {
        setCookie('essentialCookies', 1, 30, true);
        setCookie('performanceCookies', performanceCookies ? 1 : 0, 30, true);
        setCookie('functionalCookies', functionalCookies ? 1 : 0, 30, true);

        this.essential();
        functionalCookies && this.functional();
        performanceCookies && this.performance();
    },
    essential() {
        if (navigator.cookieEnabled) {
            const currentLang = this.languageSetting();
            this.$i18n.locale = currentLang;
            localStorage.setItem('lang', currentLang);

            const unit = localStorage.getItem('unit');
            if (!unit && typeof unit === "object") { // 없을 경우 초기값을 미터법으로 세팅한다.
                localStorage.setItem("unit", 'imperial');
                this.changeUnitToVueX('imperial');
            } else {
                this.changeUnitToVueX(unit);
            }
        }
    },
    performance() {
        if (navigator.cookieEnabled) {
            const isSupported = this.$fbConf.isSupported;

            if (isSupported)
                firebase.analytics();

            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }

            gtag('js', new Date());
            gtag('config', 'G-M5TZ02M2MX');
        }
    },
    functional() {
        if (navigator.cookieEnabled)
            FirebaseConf?.initialize(true);
    },
    checkDeleteCookie(functional = false, performance = false) {
        if (navigator.cookieEnabled) {
            if (!functional) {
                FirebaseConf?.deleteFirebaseDB();
                cookiesList.functional.map((item) => {
                    const date = new Date();
                    setCookie(item, 'null', date.toUTCString(), true);
                })
            }

            if (!performance) {
                cookiesList.performance.map((item) => {
                    const date = new Date();
                    setCookie(item, 'null', date.toUTCString(), true);
                })
            }
        }
    },
}